import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import DateSelect from "../../../ui-library/DateAndTime/Date/DateSelect";
import SmartTimePicker from "../TimePicker/TimePicker";

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 413px) {
    flex-direction: column;
    width: 100%;

    .date-select-wrapper {
      margin-right: 0 !important;

      .date-picker-wrapper {
        width: 100%;
      }
    }

    .time-wrapper {
      margin-top: 10px;
    }
  }
`;

const DateAndTime = (props) => {
  const {
    dateClassName,
    timeClassName,
    validate,
    onValidate,
    onChange,
    maxDate,
    minDate,
    readOnly,
    defaultDate,
    defaultTime,
    onError,
    timeIntervals = 1,
    timeFormat,
  } = props;

  const [eventDate, setEventDate] = useState("");
  const [eventTime, setEventTime] = useState("");
  const [showErrorDate, setShowErrorDate] = useState(false);
  const [isValidDate, setIsValidDate] = useState(true);

  const [maxTime, setMaxTime] = useState(null);

  const validateDateAndTime = useCallback(() => {
    const hasErrors = eventTime === "";

    onValidate(!hasErrors, {
      date: eventDate,
      startTime: eventTime,
    });
  }, [eventTime, onValidate, eventDate]);

  const onChangeDate = (date) => {
    onChange(true, {
      date: date,
      startTime: eventTime,
    });
  };

  useEffect(() => {
    if (
      !eventDate ||
      moment(eventDate).startOf("day").isSame(moment().startOf("day"))
    ) {
      setMaxTime(moment().toDate());
    } else {
      setMaxTime(moment(eventDate).endOf("day").toDate());
    }
  }, [eventDate, maxDate]);

  useEffect(() => {
    setEventDate(defaultDate);
  }, [defaultDate]);

  useEffect(() => {
    setEventTime(defaultTime);
  }, [defaultTime]);

  useEffect(() => {
    if (validate) {
      validateDateAndTime();
    }
  }, [validate, validateDateAndTime]);

  const errorHandling = {
    showErrorDate: showErrorDate,
    setShowErrorDate: setShowErrorDate,
    isValidDate: isValidDate,
    setIsValidDate: setIsValidDate,
  };

  const handleTimeChange = (value) => {
    setEventTime(value);

    onChange(true, {
      date: eventDate,
      startTime: value,
    });
  };

  return (
    <StyledWrapper data-testid="date-time">
      <div className={dateClassName}>
        <DateSelect
          eventDate={eventDate}
          maxDate={maxDate}
          minDate={minDate}
          setEventDate={setEventDate}
          errorHandling={errorHandling}
          onChange={onChangeDate}
          readOnly={readOnly}
        />
      </div>
      <div className={timeClassName}>
        <SmartTimePicker
          id="time-picker"
          onChange={handleTimeChange}
          value={eventTime}
          readOnly={readOnly}
          maxTime={maxTime}
          onError={(error) => onError(error)}
          timeIntervals={timeIntervals}
          participantTimeFormat={timeFormat}
        />
      </div>
    </StyledWrapper>
  );
};

export default withTheme(DateAndTime);
